import React from 'react';
import { Link } from 'react-router-dom';
import FacebookConnect from './FacebookConnect';

const FB_PAGE = 'https://www.facebook.com/profile.php?id=61588315298124';
const FB_GROUP = 'https://www.facebook.com/share/g/1EtE5gmiYx/';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <>
      <FacebookConnect />
      <footer className="bg-white/60 border-t border-vd-soft" data-testid="vd-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="font-serif text-xl text-vd-text mb-3">Val Dotika</h3>
              <p className="text-sm text-vd-muted leading-relaxed max-w-md">
                Prostor, kjer mamica ni sama. Digitalno drevo podpore za dneve pred zanositvijo, med nosečnostjo in po porodu.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold tracking-[0.14em] uppercase text-vd-secondary mb-3">Podstrani</h4>
              <nav className="space-y-2 text-sm">
                <Link to="/prvi-dnevi-po-porodu" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Prvi dnevi po porodu</Link>
                <Link to="/uciva-se-hranjenja" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Učiva se hranjenja</Link>
                <Link to="/tvoje-telo" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Tvoje telo</Link>
                <Link to="/povezanost" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Povezanost</Link>
                <Link to="/blog" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Blog</Link>
              </nav>
            </div>

            <div>
              <h4 className="text-xs font-semibold tracking-[0.14em] uppercase text-vd-secondary mb-3">Val Dotika</h4>
              <nav className="space-y-2 text-sm">
                <Link to="/o-val-dotika" className="block text-vd-text/80 hover:text-vd-accent transition-colors">O Val Dotika</Link>
                <Link to="/o-drustvu" className="block text-vd-text/80 hover:text-vd-accent transition-colors">O društvu</Link>
                <Link to="/politika-zasebnosti" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Politika zasebnosti</Link>
                <Link to="/pogoji-sodelovanja" className="block text-vd-text/80 hover:text-vd-accent transition-colors">Pogoji sodelovanja</Link>
                <a
                  href={FB_PAGE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-vd-text/80 hover:text-vd-accent transition-colors"
                  data-testid="footer-fb-page"
                >
                  Facebook Val Dotika
                </a>
                <a
                  href={FB_GROUP}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block text-vd-text/80 hover:text-vd-accent transition-colors"
                  data-testid="footer-fb-group"
                >
                  Skupnost Porodniški dopust, ki to ni
                </a>
                <a href="mailto:info@valdotika.si" className="block text-vd-text/80 hover:text-vd-accent transition-colors">info@valdotika.si</a>
              </nav>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-vd-soft text-center">
            <p className="text-vd-muted text-[11px] font-semibold tracking-[0.18em] uppercase mb-2">Društvo Val Dotika</p>
            <p className="text-vd-muted text-xs leading-relaxed max-w-xl mx-auto">
              Društvo za podporo družinam in otrokom Val Dotika<br />
              Ulica heroja Marinclja 6, 1330 Kočevje
            </p>
            <p className="text-vd-muted/80 text-[11px] mt-2 tracking-wide">
              Matična številka: 2947145000 &nbsp;·&nbsp; Davčna številka: 51988780
            </p>
            <p className="text-vd-muted/70 text-xs mt-4">&copy; {year} Val Dotika. Vse pravice pridržane.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
